// extracted by mini-css-extract-plugin
export var equalColumn = "_f2-0";